var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-key-stats"},[_c('div',{staticClass:"market-key-stats__title"},[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_c('div',{staticClass:"market-key-stats__content"},_vm._l((_vm.items),function(elem,index){return _c('market-key-stats-element',{key:index,attrs:{"widget":elem}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d40979d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/market-key-stats/market-key-stats.vue
// module id = Bmi9
// module chunks = 0